import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api, ApiError } from '../api/client'
import type { SceneMeta } from '../api/types'

export default function SceneSidebar() {
  const { t } = useTranslation()
  const { sceneId } = useParams()
  const nav = useNavigate()
  const [scenes, setScenes] = useState<SceneMeta[]>([])
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    api
      .listScenes()
      .then((r) => {
        if (alive) setScenes(r.scenes)
      })
      .catch((e: unknown) => {
        if (alive) setError(e instanceof ApiError ? e.message : 'Failed to load scenes')
      })
    return () => {
      alive = false
    }
  }, [])

  return (
    <aside className="scene-sidebar">
      <div className="sidebar-label">{t('studio.scenes')}</div>
      {error && <div className="error-box">{error}</div>}
      {scenes.map((s) => (
        <button
          key={s.id}
          className={`sidebar-scene${s.id === sceneId ? ' active' : ''}`}
          onClick={() => nav(`/s/${s.id}`)}
        >
          <span className="ss-icon">{s.icon}</span>
          <span className="ss-name">{s.name}</span>
        </button>
      ))}
    </aside>
  )
}
